















































import {Component, Vue} from 'vue-property-decorator'
import * as firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import "firebase/storage"
import Login from '@/components/Login.vue'
import Edit from '@/components/Edit.vue'
import Upload from '@/components/Upload.vue'

const db = firebase.firestore()

@Component({
  components: {Upload, Edit, Login},
})
export default class Manage extends Vue {
  private voiceDataList: VoiceData[] = []
  private headers = [
    {text: 'Title', value: 'title'},
    {text: 'Index', value: 'index', width: "10%"},
    {text: 'Tags', value: 'tags', width: "45%"},
    {text: 'Voice', value: 'voiceUrl', width: "5%", align: 'center'},
    {text: 'Archive', value: 'archiveUrl', width: "5%", align: 'center'},
  ]

  private selected: (VoiceData & {id: string})[] = []
  private search = ""
  private isLoading = true
  private addDialog = false
  private editDialog = false
  private loginDialog = false
  private deleteDialog = false
  private editData: VoiceData | null = null

  private mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.loginDialog = true
      } else {
        this.loginDialog = false
        db.collection('admin')
          .doc(user.uid)
          .get()
          .then((snap) => {
            if (!snap.exists) {
              throw "関係者以外立入禁止"
            }
            return db.collection('voices')
              .orderBy('ruby')
              .orderBy('index')
              .onSnapshot((snap) => {
                this.isLoading = true
                this.voiceDataList = snap.docs.map((v) => {
                  const ret = v.data() as VoiceData & { id: string }
                  ret.id = v.id
                  return ret
                })
                this.isLoading = false
              })
          })
          .catch((err) => {
            this.$store.commit('showAlert', {msg: err, color: "error"})
            this.$router.push("/")
          })
      }
    })
  }

  private update(id: string, data: VoiceData) {
    db.collection('voices')
      .doc(id)
      .update(data)
      .then(() => {
        this.editDialog = false
      })
  }

  private deleteVoice() {
    const storage = firebase.storage()
    this.selected.forEach((v) => {
      storage.refFromURL(v.voiceUrl).delete()
      .then(() => {
        const id = v.id
        delete v.id
        return db.collection('voices').doc(id).delete()
      }).then(() => {
        this.$store.commit('showAlert', {msg: `${v.title}を削除しました`, color: 'success'})
      })
    })
    this.deleteDialog = false
  }

  private showDeleteDialog() {
    if (this.selected.length > 0) {
      this.deleteDialog = true
    }
  }

  private showEditDialog(data: VoiceData) {
    this.editData = Object.assign({}, JSON.parse(JSON.stringify(data)))
    this.editDialog = true
  }

  private playVoice(url: string) {
    const audio = new Audio(url)
    audio.play()
  }
}
